module.exports = __webpack_public_path__ + "static/media/90-landcruiser-2.b4fa406b.webp";